export const JP = 'ja-JP'
export const EN = 'en-US'